import React from "react";
import {
  Card, CardContent, Grid
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import I18n from "../../../../../../base/i18n.js.jsx";
import { itemWithKeys } from "../../../../../../utils/utils.js.jsx";
import FormFields from "../../../../../../base/form/form_fields.js.jsx";

import pageStyles from "../../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../../base_info_page.js.jsx";
import cardStyles from "./card_styles.js";

import { AdminIdentityUserModel } from "../../../../../../models/users/admin/identity_user_model.js";
import { AdminUserIdentityInfoModel } from "../../../../../../models/users/admin/user_identity_info_model.js"

const styles = theme => ({
});

const IdentityDataCard = (props) => {

  const { classes, onItemChanged, errorData } = props;

  const user = Object.assign({}, props.user) || {};
  user.personalInfo = itemWithKeys(user.personalInfo, AdminUserIdentityInfoModel.formFieldsWhitelist(user.personalInfo))

  const formFields = AdminIdentityUserModel.formFields({item: user});

  const identityFields = ["personalInfo"];

  return (
    <Card className = { classes.card }>
      <CardContent>
        <div className = { classes.cardTitle } >
          { I18n.t("admin.users.user.field_group.identity_data")}
        </div>
        <FormFields formFields = { formFields.filter(field => identityFields.includes(field.name)) }
                    item = { itemWithKeys(user, identityFields) }
                    errorData = { errorData }
                    onItemChange = { onItemChanged } />
      </CardContent>
    </Card>
  );
}

IdentityDataCard.defaultProps = {
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...cardStyles(theme),
    ...styles(theme)
  }),
  { withTheme: true }
)(IdentityDataCard);
